module.exports = __webpack_public_path__ + "img/Newbie_Shield_01_Warrior.87ea1635.png";